/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { FlatTaskEvaluationInputDimensions } from './flatTaskEvaluationInputDimensions';

/**
 * Essay-style flat dimension evaluation.
 */
export interface FlatTaskEvaluationInput {
  kind?: 'flat';
  dimensions: FlatTaskEvaluationInputDimensions;
}
